class BlocImplantation {
  constructor(rootEl) {
    this.rootEl = rootEl;

    this.carteEl = this.rootEl.querySelector('.carte');
    this.carte = new Carte(this.carteEl);

    this.collapseEl = this.rootEl.querySelector('[data-collapse="yes"]');

    this.accordeonDataCollapsed = this.rootEl.querySelectorAll('.containerCarteFrance__content > [data-collapse="yes"] > div > p');

    this.init();
  }

  init() {
    this.carteEl.addEventListener('carteClicRegion', (e) => {
      const regionId = e.detail.region.id;
      const regionAccordeonEl = this.collapseEl.querySelector(`[data-region-id="${regionId}"]`);

      if (!regionAccordeonEl) return;

      this.accordeonDataCollapsed.forEach((el) => {
        if (el.getAttribute('data-collapsed') == 'no') {
          el.dispatchEvent(new CustomEvent('click'));
        }
      });

      this.currentRegionAccordeonEl = regionAccordeonEl;

      regionAccordeonEl.dispatchEvent(new CustomEvent('click'));
    });
  }
}

// ===================================================================================
// ===================================================================================
// ===================================================================================

class BlocCarteInternationale {
  constructor(rootEl) {
    this.rootEl = rootEl;

    this.mapContainerEl = this.rootEl.querySelector('.containerCarteInternationale__containerCarte');
    this.contentContainerEl = this.rootEl.querySelector('.containerCarteInternationale__containerContenu');

    this.mapInternationaleElsObj = {};
    this.mapInternationaleEls = this.rootEl.querySelectorAll('.carte.carte--internationale');
    this.mapInternationaleEls.forEach((mapInternationaleEl) => {
      this.mapInternationaleElsObj[mapInternationaleEl.getAttribute('data-map-name')] = mapInternationaleEl;
    });

    this.switchButtonElsObj = {};
    this.switchButtonEls = this.rootEl.querySelectorAll('[data-button-map-name]');
    this.switchButtonEls.forEach((switchButtonEl) => {
      this.switchButtonElsObj[switchButtonEl.getAttribute('data-button-map-name')] = switchButtonEl;
    });

    this.currentMapEl = null;

    this.cartes = [];
    this.carteEls = this.rootEl.querySelectorAll('.carte');
    this.carteEls.forEach((carteEl) => {
      this.cartes.push(new Carte(carteEl));
    });

    this.tileElsObj = {};
    this.tileEls = this.rootEl.querySelectorAll('.containerCarteInternationale__tuile');
    this.tileEls.forEach((tileEl) => {
      this.tileElsObj[tileEl.getAttribute('data-area-id')] = tileEl;
    });
    this.currentTileEl = null;

    this.mobileBreakpoint = 1024;
    this.inMobileMode = true;
    this.resizeTimer = null;

    this.init();
  }

  init() {
    this.mapInternationaleEls.forEach((mapInternationaleEl) => {
      mapInternationaleEl.style.display = 'none';
    });

    this.switchButtonEls.forEach((switchButtonEl) => {
      switchButtonEl.addEventListener('click', (e) => {
        e.preventDefault();
        const mapToDisplayName = e.target.getAttribute('data-button-map-name');
        this.switchToMap(mapToDisplayName);
        this.switchToRegion(mapToDisplayName);
      });
    });

    this.carteEls.forEach((carteEl) => {
      carteEl.addEventListener('carteClicRegion', (e) => {
        const regionId = e.detail.region.id;
        this.switchToRegion(regionId);
      });
    });

    const accordeonMobileEls = document.querySelector('.containerCarteInternationale__containerContenu--mobile');

    accordeonMobileEls.querySelectorAll('.containerCarteInternationale__tuile>h3').forEach((h3El) => {
      h3El.classList.add('accordeon__titre');
    });

    accordeonMobileEls.querySelectorAll('.containerCarteInternationale__tuile>div').forEach((divEl) => {
      divEl.classList.add('accordeon__paragraphe');
    });

    window.addEventListener('resize', () => {
      this.onWindowResize();
    });

    this.updateUI();
  }

  switchToMap(mapName) {
    if (this.currentMapEl) {
      this.currentMapEl.style.display = 'none';
      this.switchButtonElsObj[this.currentMapEl.getAttribute('data-map-name')].classList.remove('button--primary');
    }

    this.currentMapEl = this.mapInternationaleElsObj[mapName];
    this.currentMapEl.style.display = 'block';
    this.switchButtonElsObj[mapName].classList.add('button--primary');

    this.displayRegionTile(mapName);
  }

  switchToRegion(regionId) {
    if (regionId == 'europe') {
      this.switchToMap('europe');
      return;
    }

    this.displayRegionTile(regionId);
  }

  displayRegionTile(regionId) {
    const region = this.tileElsObj[regionId];

    if (!region) return;

    if (this.currentTileEl) {
      this.currentTileEl.style.display = 'none';
    }

    this.currentTileEl = this.tileElsObj[regionId];
    this.currentTileEl.style.display = 'block';
  }

  onWindowResize(debounceTimeInMs = 200) {
    clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.updateUI();
    }, debounceTimeInMs);
  }

  updateUI() {
    if (window.innerWidth < this.mobileBreakpoint) {
      this.switchToMobileMode();
    } else {
      this.switchToDesktopMode();
    }

    this.switchToMap('monde');
  }

  switchToMobileMode() {
    if (this.inMobileMode) return;

    this.inMobileMode = true;

    for (const tileKey in this.tileElsObj) {
      const tileEl = this.tileElsObj[tileKey];

      if (tileKey == 'europe' || tileKey == 'monde') {
        tileEl.style.display = 'none';
        continue;
      }

      tileEl.style.display = 'block';
    }

    this.contentContainerEl.dispatchEvent(new CustomEvent('build'));
  }

  switchToDesktopMode() {
    if (!this.inMobileMode) return;

    this.inMobileMode = false;

    this.tileEls.forEach((tileEl) => {
      tileEl.style.display = '';
    });

    this.contentContainerEl.dispatchEvent(new CustomEvent('unbuild'));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialisation des cartes de france
  const containerCarteFranceEls = document.querySelectorAll('.containerCarteFrance');

  containerCarteFranceEls.forEach((containerCarteFranceEl) => {
    new BlocImplantation(containerCarteFranceEl);
  });

  // Initialisation de la carte internationale / d'europe
  const containerCarteInternationaleEls = document.querySelectorAll('.containerCarteInternationale');

  containerCarteInternationaleEls.forEach((containerCarteInternationaleEl) => {
    const blocCarteInternationale = new BlocCarteInternationale(containerCarteInternationaleEl);
    blocCarteInternationale.switchToMap('monde');
  });
});
